// Adds '-' while user is typing in GiftCard code
// Final Gift Card code should look like XXXX-XXXX-XXXX-XXXX
// Auto capitalizes all letter inputs.
export const formatGiftCardCode = (giftCardCode: string) => {
  if (!giftCardCode) return '';
  const sanitizedCode = giftCardCode.split('-').join('');
  return sanitizedCode
    .match(/.{1,4}/g)
    .join('-')
    .toUpperCase();
};
